import { useMemo } from 'react'
import useSignedUser from '@cannect/hooks/useSignedUser'

const PRESCRIBER_REGISTRATION_TYPE = 2

/**
 * Fonte única de verdade para "o usuário logado é prescritor".
 *
 * Regra de negócio: apenas prescritores (cn_users.registration_type = 2) veem a
 * classificação da Curadoria Técnica e os filtros técnicos do marketplace.
 *
 * Antes desta função a mesma pergunta era respondida de três formas diferentes
 * pelo portal (por `prescriber.id`, por `prescriber_id` e por `council`), o que
 * fazia o mesmo usuário ver a classificação em uma tela e não ver em outra.
 *
 * O fallback para `@CANNECT_USER` cobre a janela entre o login e o retorno de
 * `/my-account/information`, que é quem popula o contexto do `useSignedUser`.
 * Usuário deslogado cai no `INITIAL_USER`, cujo `registration_type` é 1.
 */
export default function useIsPrescriber(): boolean {
  const { signedUser } = useSignedUser()

  const storedRegistrationType = useMemo(() => {
    try {
      const raw = localStorage.getItem('@CANNECT_USER')
      if (!raw) return null

      return Number(JSON.parse(raw)?.registration_type) || null
    } catch {
      return null
    }
  }, [])

  if (signedUser?.registration_type === PRESCRIBER_REGISTRATION_TYPE) return true

  return storedRegistrationType === PRESCRIBER_REGISTRATION_TYPE
}
